module.exports = __webpack_public_path__ + "static/img/bg.e6c55092.jpg";